import React from "react";

import Wrapper from "./Wrapper";
import Button from "./Button";
import ButtonGroupWrapper from "./ButtonGroupWrapper";
import ButtonGroup from "./ButtonGroup";

class Add extends React.Component {
  constructor(props) {
    super(props);

    this.handleAdd = this.handleAdd.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.state = { open: false };
  }

  handleClick(e) {
    e.preventDefault();

    if (1 === this.props.property.ranges.length)
      return this.handleAdd(this.props.property, this.props.property.ranges[0]);

    this.setState(prevState => ({ open: !prevState.open }));
  }

  handleAdd(property, range) {
    if (this.props["onAdd"]) this.props["onAdd"](property, range);

    this.setState({ open: false });
  }

  render() {
    const props = this.props;
    const property = props.property;
    return (
      <Wrapper>
        <Button open={this.state.open} onClick={this.handleClick} />
        <ButtonGroupWrapper>
          <ButtonGroup open={this.state.open}>
            {property.ranges.map((r, key) => (
              <div key={key} onClick={() => this.handleAdd(property, r)}>
                {r.label}
              </div>
            ))}
          </ButtonGroup>
        </ButtonGroupWrapper>
      </Wrapper>
    );
  }
}

export default Add;
